// extracted by mini-css-extract-plugin
export var dropOver = "_ir-2";
export var dropValid = "_ir-1";
export var hidden = "_ir-3";
export var line = "_ir-0";